import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { coffeeChat } from '../../data/foundingOffer';
export function CoffeeChatInvite() {
  return <section id="coffee-chat" aria-labelledby="coffee-chat-heading" className="max-w-5xl mx-auto px-6 mt-20 md:mt-24 scroll-mt-28" data-id="element-484" data-mp="2luibvzjv7o54">
      <div className="grid items-center gap-10 rounded-[2rem] bg-purple-100 px-6 py-10 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:gap-14 md:px-12 md:py-14" data-id="element-485" data-mp="2vmo5tetogfmy">
        {/* Host portrait */}
        <figure className="mx-auto w-full max-w-xs md:max-w-none" data-id="element-486" data-mp="35jsrldjm2938">
          <div className="aspect-[4/5] overflow-hidden rounded-3xl border-4 border-white bg-purple-200 shadow-xl" data-id="element-487" data-mp="35mevn37am6gp">
            {coffeeChat.hostPhotoUrl ? <img src={coffeeChat.hostPhotoUrl} alt={`${coffeeChat.hostName}, ${coffeeChat.hostTitle}`} className="h-full w-full object-cover object-[45%_center]" data-id="element-488" data-mp="3ejyyggkt0atf" /> : <div role="img" aria-label={`${coffeeChat.hostName}, ${coffeeChat.hostTitle}`} className="flex h-full w-full items-center justify-center" data-id="element-489" data-mp="2hn7weydiip33">
                <span aria-hidden="true" className="font-serif text-6xl text-purple-800" data-id="element-490" data-mp="28uef6vei9fml">
                  MG
                </span>
              </div>}
          </div>
          <figcaption className="mt-4 text-center md:text-left" data-id="element-491" data-mp="30m3mpym92jbn">
            <span className="block font-serif text-xl text-charcoal" data-id="element-492" data-mp="30laqhrkx3c7r">{coffeeChat.hostName}</span>
            <span className="block text-sm text-charcoal/65" data-id="element-493" data-mp="2wla0rasdbele">{coffeeChat.hostTitle}</span>
          </figcaption>
        </figure>

        {/* Copy + CTA */}
        <div data-id="element-494" data-mp="2mmubzegtchf2">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-4" data-id="element-495" data-mp="2ml9fhjaxuoek">
            Fem Entity Practitioner Coffee Chats
          </p>
          <h2 id="coffee-chat-heading" className="font-serif text-3xl md:text-5xl text-charcoal leading-tight" data-id="element-496" data-mp="1b75p0n3k7ie9">
            Have questions? Let’s talk.
          </h2>

          <div className="mt-6 space-y-4 text-base md:text-lg text-charcoal/75 leading-relaxed" data-id="element-497" data-mp="1hn5t3lrvjzph">
            <p data-id="element-498" data-mp="13nwnfg1aonzr">
              Joining a new network comes with questions. Practitioner Coffee Chats are an opportunity to
              connect directly with the Fem Entity team, learn more about the network, and get your
              questions answered before or after joining.
            </p>
            <p data-id="element-499" data-mp="yojss946mcmm">
              Meet <strong className="font-semibold text-charcoal" data-id="element-500" data-mp="yotgtr5o29po">Michelle Gibson</strong>, Fem Entity
              Advisor and counselling practice owner, for a casual virtual conversation about the platform, membership,
              onboarding, and what being part of the Fem Entity practitioner network looks like.
            </p>
            <p data-id="element-501" data-mp="azhcb4laaptp">
              Whether you’re considering joining or already getting set up, come grab a coffee and chat
              with us.
            </p>
          </div>

          <a href={coffeeChat.registrationUrl} target="_blank" rel="noopener noreferrer" className="mt-9 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-purple-700 px-8 py-4 text-base font-semibold text-white transition-colors duration-200 ease-out hover:bg-purple-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-purple-100" data-id="element-502" data-mp="3sgv29ixhahe3">
            Register for a Coffee Chat
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-503" data-mp="a9ysgogglv8b" />
            <span className="sr-only" data-id="element-504" data-mp="ozmlz3iefplh">(opens Zoom registration in a new tab)</span>
          </a>
        </div>
      </div>
    </section>;
}